import Helpers from './../helpers/utility';
var isObject = Helpers.isObject;
/**
 * Set a dot-notated property by unwinding it onto an object, e.g.
 * set({}, 'a.b.c', 'foo') => { a: { b: { c: 'foo' }}}
 *
 * If an object already exists at a non-leaf target, the new
 * path will be merged onto the existing object.
 *
 * @param {object} target the target to assign to
 * @param {string} prop the dot-notated property tree
 * @param {any} value the value to assign
 * @returns {object} the target
 */
export default function set(target, prop, value) {
    var parts = prop.split('.');
    var cur = target;
    parts.forEach(function (part, index) {
        if (index === parts.length - 1) {
            cur[part] = value;
        }
        else if (!isObject(cur[part])) {
            cur[part] = {};
        }
        cur = cur[part];
    });
    return target;
}
//# sourceMappingURL=set.js.map